import React from 'react';
import LegendHeader from '../legendHeader';
import TabsTable from '../tabs/tabsTable';
import AccordionTable from '../accordion/accordionTable';
import NoDataMessage from '../noDataMessage/noDataMessage';
import HeaderTable from '../headerTable/headerTable';
import { openLinkParent } from '../../../functions/functions';

export default function TableNFL({ dataTab1, sport, version }) {

  if (!dataTab1?.football?.[0]) {
    return <NoDataMessage title="Posiciones" />;
  }

  const conferences = dataTab1.football[0].conferences || [];

  if (conferences.length === 0) {
    return <NoDataMessage title="Posiciones" />;
  }
  const renderConferenceTable = (conference) => (
    <div className="table-content">
      <div className="conference-section marginB10">
        <h3 className="conference-title">{conference.name}</h3>
        {conference.divisions?.map((division, divIndex) => (
          <div key={`${division.divisionsId}-${divIndex}`} className="division-section">
            <table className="positions-table">
              <thead>
                <tr>
                  <th className="division-title">{division.abbreviation}</th>
                  <th>W</th>
                  <th>L</th>
                  <th>T</th>
                  <th>PCT</th>
                  <th>STRK</th>
                </tr>
              </thead>
              <tbody>
                {division.teams?.map((team) => {
                  const hasValidUrl = team.url_wp?.length > 0 && version != 'us';
                  return (
                    <tr key={team.teamId}>
                      <td className="team-item" {...(hasValidUrl && { onClick: () => openLinkParent(team.url_wp, false) })}>
                        <img
                          src={team.image}
                          alt={`Logo ${team.abbreviation}`}
                          loading="lazy"
                          onError={(e) => e.target.src = 'assets/default.png'}
                        />
                        <span className={hasValidUrl ? "team-abbreviation item-link" : "team-abbreviation"}>{team.abbreviation}</span>
                      </td>
                      <td className="team-item">{team.record?.wins || '-'}</td>
                      <td className="team-item">{team.record?.losses || '-'}</td>
                      <td className="team-item">{team.record?.ties || '0'}</td>
                      <td className="team-item">{team.record?.percentage || '-'}</td>
                      <td className="team-item">{team.streaks?.[0]?.games || '-'}</td>
                    </tr>
                  );
                }) || []}
              </tbody>
            </table>
          </div>
        )) || []}
      </div>
    </div>
  );

  const conferenceStages = conferences.map((conference, index) => ({
    id: conference?.conferenceId || `conf-${index}`,
    name: conference?.abbreviation || conference?.name || `Conference ${index + 1}`,
    ...conference
  }));

  return (
    <>
      <div className="positions-table__header">
        <HeaderTable title="Posiciones"  />
        <LegendHeader
          legends={[
            { symbol: 'X', description: 'Clinched Playoff Berth' },
            { symbol: 'Y', description: 'Clinched Division' },
            { symbol: 'Z', description: 'Clinched Division and Home Field Advantage' }
          ]}
        />
      </div>

      <div className="positions-table__sport">
        {conferences.length === 2 ? (
          <TabsTable 
            stages={conferenceStages} 
            renderTable={renderConferenceTable} 
            variant={conferences.length === 1 ? 'primary' : "nested"}
            initialActiveTab={0}
          />
        ) : conferences.length > 2 ? (
          <AccordionTable stages={conferenceStages} renderTable={renderConferenceTable} />
        ) : conferences.length === 1 ? (
          renderConferenceTable(conferences[0])
        ) : (
          <div className="no-data">No hay datos disponibles</div>
        )}
      </div>
    </>
  );
}